import { z } from 'zod';
import { ROLES } from '../dominio/enums.js';
import { emailSchema, enumDe, idSchema, passwordSchema, rutSchema, textoOpcional, textoRequerido } from './comunes.js';
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Ingresa tu contraseña'),
});
/**
 * Registro de una empresa nueva. Crea el tenant y su usuario `OWNER` en una
 * sola transacción: no tiene sentido un tenant sin dueño ni un dueño sin empresa.
 */
export const registroSchema = z.object({
    empresa: z.object({
        nombre: textoRequerido(200, 'El nombre de la empresa'),
        rut: rutSchema,
    }),
    usuario: z.object({
        nombre: textoRequerido(120, 'Tu nombre'),
        email: emailSchema,
        password: passwordSchema,
    }),
});
export const refrescarSchema = z.object({
    refreshToken: z.string().min(1),
});
export const cambiarPasswordSchema = z
    .object({
    passwordActual: z.string().min(1, 'Ingresa tu contraseña actual'),
    passwordNueva: passwordSchema,
    confirmacion: z.string(),
})
    .refine((datos) => datos.passwordNueva === datos.confirmacion, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmacion'],
})
    .refine((datos) => datos.passwordNueva !== datos.passwordActual, {
    message: 'La nueva contraseña debe ser distinta de la actual',
    path: ['passwordNueva'],
});
export const crearUsuarioSchema = z.object({
    nombre: textoRequerido(120, 'El nombre'),
    email: emailSchema,
    password: passwordSchema,
    rol: enumDe(ROLES),
});
export const actualizarUsuarioSchema = z.object({
    nombre: textoRequerido(120, 'El nombre').optional(),
    rol: enumDe(ROLES).optional(),
    activo: z.boolean().optional(),
});
export const actualizarTenantSchema = z.object({
    nombre: textoRequerido(200, 'El nombre de la empresa').optional(),
    rut: rutSchema,
    direccion: textoOpcional(255),
    telefono: textoOpcional(50),
    emailContacto: emailSchema.optional(),
    ivaPct: z.number().min(0).max(100).optional(),
    condicionPagoDefault: z.string().optional(),
});
export const usuarioIdSchema = z.object({ id: idSchema });
//# sourceMappingURL=auth.js.map